import React from 'react';
import { FaCircleCheck } from "react-icons/fa6";
import { FaCircleXmark } from "react-icons/fa6";

const data = {
    "2024": {
        "Jan": true,
        "Feb": true,
        "Mar": true,
        "Apr": true,
        "May": true,
        "Jun": true,
        "Jul": true,
        "Aug": true,
        "Sep": true,
        "Oct": true,
        "Nov": true,
        "Dec": true
        },
        "2023": {
        "Jan": true,
        "Feb": true,
        "Mar": true,
        "Apr": true,
        "May": true,
        "Jun": true,
        "Jul": true,
        "Aug": true,
        "Sep": true,
        "Oct": true,
        "Nov": true,
        "Dec": true
        },
        "2022": {
        "Jan": true,
        "Feb": true,
        "Mar": true,
        "Apr": true,
        "May": true,
        "Jun": true,
        "Jul": true,
        "Aug": true,
        "Sep": true,
        "Oct": true,
        "Nov": true,
        "Dec": true
        },
        "2021": {
        "Jan": true,
        "Feb": true,
        "Mar": true,
        "Apr": true,
        "May": true,
        "Jun": true,
        "Jul": true,
        "Aug": true,
        "Sep": true,
        "Oct": true,
        "Nov": true,
        "Dec": true
        },
        "2020": {
        "Jan": true,
        "Feb": true,
        "Mar": true,
        "Apr": true,
        "May": true,
        "Jun": true,
        "Jul": true,
        "Aug": true,
        "Sep": true,
        "Oct": true,
        "Nov": true,
        "Dec": true
        },
        "2019": {
        "Jan": true,
        "Feb": true,
        "Mar": true,
        "Apr": true,
        "May": true,
        "Jun": true,
        "Jul": true,
        "Aug": true,
        "Sep": true,
        "Oct": true,
        "Nov": true,
        "Dec": true
        }
    }

const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    

const HdfcHistory = () => {
    return (
    <div className='flex flex-col max-md:items-center overflow-hidden max-md:w-full'>
        <div className='text-left my-2'><p>Payment History</p></div>
        <div className='flex max-md:flex-col max-md:items-center justify-between max-md:w-[98%]'>
        <ul className='flex flex-col w-full md:w-[30%] lg:w-[42%] overflow-hidden rounded-lg h-40 md:h-60 mb-2'>
            <li className='px-2 md:px-1 w-full lg:px-6 flex justify-between items-center bg-gray-200 h-1/6'>
                <p className='text-gray-500 text-xs max-lg:text-[10px]'>Account Open Date : </p>
                <p className='text-xs max-lg:text-[10px]'>24-05-2019</p>
            </li>
            <li className='px-2 md:px-1 w-full lg:px-6 flex justify-between items-center bg-gray-100 h-1/6'>
                <p className='text-gray-500 text-xs max-lg:text-[10px]'>Last Payment Date : </p>
                <p className='text-xs max-lg:text-[10px]'>31-10-2023</p>
            </li>
            <li className='px-2 md:px-1 w-full lg:px-6 flex justify-between items-center bg-gray-200 h-1/6'>
                <p className='text-gray-500 text-xs max-lg:text-[10px]'>No. Of On-time Payments : </p>
                <p className='text-xs max-lg:text-[10px]'>54</p>
            </li>
            <li className='px-2 md:px-1 w-full lg:px-6 flex justify-between items-center bg-gray-100 h-1/6'>
                <p className='text-gray-500 text-xs max-lg:text-[10px]'>No. Of Missed Payments : </p>
                <p className='text-xs max-lg:text-[10px]'>0</p>
            </li>
            <li className='px-2 md:px-1 w-full lg:px-6 flex justify-between items-center bg-gray-200 h-1/6'>
                <p className='text-gray-500 text-xs max-lg:text-[10px]'>Account Overdue : </p>
                <p className='text-xs max-lg:text-[10px]'>24-05-2019</p>
            </li>
            <li className='px-2 md:px-1 w-full lg:px-6 flex justify-between items-center bg-gray-100 h-1/6'>
                <p className='text-gray-500 text-xs max-lg:text-[10px]'>Account Status : </p>
                <p className='text-xs max-lg:text-[10px]'>Active</p>
            </li>
        </ul>

        <div className='w-full md:w-[68%] lg:w-[56%] overflow-hidden border border-gray-300 rounded-lg md:h-60 h-52 mb-2 max-md:mt-1'>
            <div className='flex text-center items-center justify-normal gap-0 overflow-hidden h-[20%]'>
            <p className='border-r border-b border-gray-300 w-full h-full text-[8px] md:text-[10px] lg:text-xs font-semibold text-center items-center flex justify-center'>DPD</p>
                {months.map((month) => {
                    return <p className='border-r border-b border-gray-300 w-full h-full text-[10px] md:text-xs lg:font-semibold text-center items-center flex justify-center'>{month}</p>
                })
                }
            </div>
            <div className='w-full h-[80%]'>
            {
                Object.entries(data).map((year)=>{
                    //console.log(year[0])
                    return <div className='flex text-center items-center justify-normal gap-0 overflow-hidden h-1/6'>
                    <p className='border-r border-b border-gray-300 w-full h-full text-[8px] md:text-[10px] lg:text-xs lg:font-semibold text-center items-center flex justify-center'>{year[0]}</p>
                        {Object.entries(year[1]).map((month)=>{
                            return <p className='border-r border-b border-gray-300 w-full h-full text-xs font-bold text-center items-center flex justify-center'>{month[1]?<FaCircleCheck className='text-primary text-xs md:text-sm lg:text-lg'/> : <FaCircleXmark className='text-primary text-xs md:text-sm lg:text-lg'/>}</p>
                        })}
                    </div>
                })
            }
            </div>
        </div>

        </div>
    </div>
    )
}

export default HdfcHistory